import {
  Component,
  EventEmitter,
  OnInit,
  OnChanges,
  Output,
  Input,
  SimpleChanges
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { SettingsService } from '../../../../common/settings.service';
import { EventCustomerDetails } from '../../../../../models/event-customer-details.model';
import { CommonSharedModule } from '../../../../common/shared.module';
import { EventDashboardService } from '../../../../services/event-dashboard.service';

@Component({
  selector: 'app-one-to-one-customer-details',
  templateUrl: './one-to-one-customer-details.component.html',
  styleUrls: ['./one-to-one-customer-details.component.scss'],
  standalone: true,
  imports: [CommonSharedModule]
})
export class OneToOneCustomerDetailsComponent implements OnInit, OnChanges {
  @Output() refreshPartnerInput = new EventEmitter<void>();
  @Output() refreshEventDetails = new EventEmitter();
  @Input() eventId!: number;
  formCustomer!: FormGroup;
  custmsgs!: any[];
  custbtnNav = false;
  isReadonlycust = true;
  msgsPoe!: any[];
  loading = false;

  constructor(
    private formBuilder: FormBuilder,
    private eventDashboardService: EventDashboardService,
    public settings: SettingsService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['eventId'].firstChange === false) {
      this.ngOnInit();
    }
  }

  ngOnInit() {
    this.formCustomer = this.formBuilder.group({
      tPID: [''],
      pmotPID: [''],
      tPName: [''],
      pmotPName: [''],
      customerTPIDListbasedonTenantID: [''],
      segmentGroup: [''],
      pmocustomerArea: [''],
      pmocustomerCountry: [''],
      pmousageArea: [''],
      pmousageCountry: [''],
      tenantID: [''],
      pmotenantID: [''],
      tenantName: [''],
      pmotenantName: [''],
      domainName: [''],
      pmodomainName: [''],
      tenantListbasedonTPID: ['']
    });

    this.getEventCustomerDetailsById(this.eventId);
  }

  getEventCustomerDetailsById(eventId: number) {
    this.loading = true;
    this.eventDashboardService
      .getOneToOneEventCustomerDetails(eventId)
      .subscribe(result => {
        if (!result) {
          return;
        }

        const historyData = result.eventCustomerDetailsHistory;
        this.formCustomer.patchValue({
          tPID: historyData.tpid,
          tPName: historyData.tpName,
          customerTPIDListbasedonTenantID:
            historyData.customerTPIdListBasedOnTenantId,
          customerArea: historyData.customerArea,
          customerCountry: historyData.customerCountry,
          usageArea: historyData.usageArea,
          usageCountry: historyData.usageCountry,
          tenantID: historyData.tenantId,
          tenantName: historyData.tenantName,
          domainName: historyData.domainName,
          tenantListbasedonTPID: historyData.tenantListBasedOnTPId,
          pmotPID: result.tpid,
          pmocustomerArea: result.customerArea,
          pmocustomerCountry: result.customerCountry,
          segmentGroup: result.segmentGroup,
          pmousageArea: result.usageArea,
          pmousageCountry: result.usageCountry,
          pmotenantID: result.tenantId,
          pmodomainName: result.domainName,
          pmotenantName: result.tenantName,
          pmotPName: result.tpName
        });
      });
    this.loading = false;
  }

  onSubmitCustomer() {
    const updateCustomer: EventCustomerDetails = {
      tpid: this.formCustomer.controls['pmotPID'].value,
      tpName: this.formCustomer.controls['pmotPName'].value,
      customerTPIdListBasedOnTenantId:
        this.formCustomer.controls['customerTPIDListbasedonTenantID'].value,
      segmentGroup: this.formCustomer.controls['segmentGroup'].value,
      customerArea: this.formCustomer.controls['pmocustomerArea'].value,
      customerCountry: this.formCustomer.controls['pmocustomerCountry'].value,
      usageArea: this.formCustomer.controls['pmousageArea'].value,
      usageCountry: this.formCustomer.controls['pmousageCountry'].value,
      tenantId: this.formCustomer.controls['pmotenantID'].value,
      tenantName: this.formCustomer.controls['pmotenantName'].value,
      domainName: this.formCustomer.controls['pmodomainName'].value,
      eventRegistrationId: this.eventId
    } as any;

    this.eventDashboardService
      .updateCustomerDetails(updateCustomer)
      .subscribe(response => {
        if (response) {
          this.isReadonlycust = !this.isReadonlycust;
          this.custbtnNav = !this.custbtnNav;
          this.getEventCustomerDetailsById(this.eventId);
          this.custmsgs = [];
          this.custmsgs.push({
            severity: 'success',
            detail: 'Records Saved Successfully.'
          });
          this.formCustomer.disable();
        } else {
          this.custmsgs = [];
          this.custmsgs.push({ severity: 'error', detail: 'Error occurred.' });
        }
      });
  }

  editCustomerCancel() {
    this.getEventCustomerDetailsById(this.eventId);
    this.isReadonlycust = true;
    this.custmsgs = [];
    this.custbtnNav = false;
  }

  editCustomer() {
    this.isReadonlycust = false;
    this.custbtnNav = true;
    this.formCustomer.enable();
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
}
